import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseApiService} from './base-api.service';
import {ICartSnapshot} from '../../types/ICartSnapshot';

@Injectable({providedIn: 'root'})
export class CartSnapshotService extends BaseApiService {
  create(clientId: string, cartId: string, snapshot: ICartSnapshot): Observable<{token: string}> {
    return this.post<{token: string}>(`clients/${clientId}/carts/${cartId}/snapshots`, {snapshot});
  }

  show(token: string): Observable<ICartSnapshot> {
    return this.get<ICartSnapshot>(`snapshots/${token}`);
  }

  destroy(token: string): Observable<null> {
    return this.delete<null>(`snapshots/${token}`);
  }

  submit(token: string, grade: 'good' | 'better' | 'best', signature: string): Observable<void> {
    return this.post<void>(`snapshots/${token}/submit`, {grade, signature});
  }
}
